import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@chatterbug/aaron'

import DetailedTutorInfoCard from 'src/ui/TutorInfoCards/DetailedTutorInfoCard/DetailedTutorInfoCard'

import LessonDetail from './subcomponents/LessonDetail/LessonDetail'

const UpcomingLessonCard = ({ tutorProps, liveLessonProps, l2Code }) => {
  return (
    <Grid
      bg="blue42"
      p={{ _: '2x', tablet: '3x' }}
      gridTemplateColumns={{
        _: '1fr',
        tablet: '1fr 270px',
      }}
      gridGap={{ _: '4x', tablet: '2x' }}
      borderRadius="1x"
    >
      <LessonDetail {...liveLessonProps} l2Code={l2Code} />
      <DetailedTutorInfoCard {...tutorProps} />
    </Grid>
  )
}

UpcomingLessonCard.propTypes = {
  tutorProps: PropTypes.object,
  liveLessonProps: PropTypes.object,
  l2Code: PropTypes.string.isRequired,
}
export default UpcomingLessonCard
